import moment from "moment-timezone";
import { localStore } from "helpers";
import store from "store";
var instance = null;

const STRONG_EMAIL_REGEX = /^\w+([\w\.\-]*\w+)?@\w+([\w\-]*\w+)?\.(\w{2,}\.){0,2}\w{2,}$/;

/**
 * @param {(...args: any[]) => void} f
 * @param {number} t
 * @param {any} [context=null]
 */
export function debounce(f, t, context = null) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(f.bind(context, ...args), t);
  };
}

/**
 * hack for deprecated react event pooling
 * @param {...*} args
 * @returns {(e: React.SyntheticEvent) => void}
 */
export function debouncedEventHandler(...args) {
  const debounced = debounce(...args);
  return function (e) {
    e.persist();
    return debounced(e);
  };
}

class CommonManager {
  constructor() {
    if (instance) {
      return instance;
    }
    instance = this;
  }

  isAccess(accessName) {
    return true;
  }

  checkAccessForAll(array) {
    return true;
  }

  displayHeader(arr) {
    return true;
  }

  calculateTimeRange = (selectedOption, zone) => {
    let startDate, endDate;

    const timeZone = moment.tz(zone.value);

    if (selectedOption === "Today" || selectedOption === "today") {
      startDate = timeZone.startOf("day").valueOf();
      endDate = timeZone.endOf("day").valueOf();
    } else if (
      selectedOption === "Last 24 Hrs" ||
      selectedOption === "last24"
    ) {
      endDate = timeZone.valueOf();
      startDate = timeZone.subtract(24, "hours").valueOf();
    } else if (
      selectedOption === "Last Week" ||
      selectedOption === "lastweek" ||
      selectedOption === "Last 7 Days"
    ) {
      endDate = timeZone.valueOf();
      startDate = timeZone
        .subtract(7, "days")
        .startOf("day")
        .valueOf();
    } else if (
      selectedOption === "Yesterday" ||
      selectedOption === "yesterday"
    ) {
      startDate = timeZone
        .subtract(1, "days")
        .startOf("day")
        .valueOf();
      endDate = timeZone.endOf("day").valueOf();
    } else if (selectedOption === "Custom Date") {
      const now = timeZone.valueOf();
      startDate = timeZone.startOf("day").valueOf();
      endDate = timeZone
        .startOf("day")
        .add(now - startDate, "milliseconds")
        .valueOf();
    } else if (selectedOption === "Tomorrow" || selectedOption === "tomorrow") {
      startDate = timeZone
        .add(1, "days")
        .startOf("day")
        .valueOf();
      endDate = timeZone.endOf("day").valueOf();
    } else if (selectedOption === "Next 7 Days") {
      startDate = timeZone.valueOf();
      endDate = timeZone
        .add(7, "days")
        .endOf("day")
        .valueOf();
    } else if (selectedOption === "Next 24 Hours") {
      startDate = timeZone.valueOf();
      endDate = timeZone.add(24, "hours").valueOf();
    }
    return { startDate, endDate };
  };

  isStrongEmail = (v) => STRONG_EMAIL_REGEX.test(v);

  isEmail = (val) => {
    let re = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    return re.test(val);
  };

  isInvalidCharacters = (val) => {
    let re = /[.,]/;
    return re.test(val);
  };
  isIp = (val) => {
    let re = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return re.test(val);
  };
  isDomain = (val) => {
    let re = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
    return re.test(val);
  };
  isDomainOrIP = (val) => {
    const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
    // const ipRegex = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;
    const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    if (domainRegex.test(val) || ipRegex.test(val)) {
      return true;
    }

    return false;
  };
  isValidPassword = (text) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(text);
  };
  isNumberOrBlank(num) {
    const regexForNumberOrBlank = /^(\s*|\d+)$/;
    return regexForNumberOrBlank.test(num);
  }
  isValidPort(num) {
    const regexForValidPort = /^((6553[0-5])|(655[0-2][0-9])|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([0-5]{0,5})|([0-9]{1,4}))$/gi;
    return regexForValidPort.test(num);
  }
  isValidURLRegex(num) {
    const regexForValidURL = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    const regexForValidURLtest = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?(\?\w*=\w*)?$/;
    return regexForValidURL.test(num);
  }
  getTenant() {
    return localStore.getItem("selected-tenant");
  }
  isValidRegex(pattern) {
    console.log('pattern', pattern)
    try {
      new RegExp(pattern); // Attempt to create a RegExp object
      return true;
    } catch (e) {
      return false; // Return false if an error is thrown
    }
  }
  getUserId() {
    const state = store.getState();
    //
    if (
      state.globalStateReducer &&
      state.globalStateReducer.currentUser &&
      state.globalStateReducer.currentUser.userId
    ) {
      return state.globalStateReducer.currentUser.userId;
    }
    return "";
  }
  formDataAppend(form) {
    const formData = new FormData();
    for (let key in form) {
      this.createFormData(formData, key, form[key]);
    }
    return formData;
  }
  createFormData(formData, key, data) {
    if (data === Object(data) || Array.isArray(data)) {
      for (var i in data) {
        this.createFormData(formData, key + "[" + i + "]", data[i]);
      }
    } else {
      formData.append(key, data);
    }
  }
  initialData(list, label = "name", value = "_id") {
    let options = [];
    if (list && list.length) {
      for (let data of list) {
        options.push({
          value: data[value] || "",
          data: data || {},
          label: data[label] || "",
        });
      }
    }
    return options;
  }
  selectedData(list) {
    let result = [];
    if (list && list.length) {
      for (let el of list) {
        if (el.data) {
          result.push(el.data);
        }
      }
    }
    return result;
  }
  selectedSingleData(_id, name, label = "name", value = "_id") {
    let result = [];
    let obj = {};
    obj[label] = name || "";
    obj[value] = _id || "";
    result.push(obj);
    //
    return result;
  }
  arrayEmpty(list) {
    if (!list || list.length == 0) {
      return true;
    }
    return false;
  }
  objectToArray(data, key = "key", value = "value") {
    let result = [];
    if (typeof data == "object" && data) {
      if (Array.isArray(data)) {
        return data;
      } else {
        for (const dKey in data) {
          if (Object.hasOwnProperty.call(data, dKey)) {
            const dValue = data[dKey];
            let t = {};
            t[key] = dKey;
            t[value] = dValue;
            result.push(t);
          }
        }
      }
    }
    return result;
  }
  maskText(text) {
    if (text && typeof text == "number") {
      text = text.toString();
    }
    if (text && typeof text == "string") {
      let inpLength = text.length;
      text =
        text.substring(0, 2) +
        text.substring(2, inpLength - 2).replace(/[0-9]/g, "*") +
        text.substring(inpLength - 2, inpLength);
    } else {
      text = "*******";
    }
    return text;
  }

  getTimeZone() {
    let timeZone = localStore.getItem("timezone");

    if (timeZone && timeZone.includes("value")) {
      timeZone = JSON.parse(timeZone);
    } else {
      let tZone = moment.tz.guess();
      timeZone = {
        value: tZone,
        label: tZone,
      };
      localStore.setItem("timezone", JSON.stringify(timeZone));
    }
    return timeZone;
  }

  generateSelect(value) {
    return {
      value: value,
      label: value,
    };
  }

  isValidUrl(urlString) {
    try {
      // Try to create a URL object
      const url = new URL(urlString);

      // Check if the protocol is either http: or https:
      return (
        url.protocol === "http:" ||
        url.protocol === "https:" ||
        url.protocol === "wss:" ||
        url.protocol === "ws:"
      );
    } catch (error) {
      // If the URL constructor throws an error, it means the URL is invalid
      return false;
    }
  }

  // isValidUrl(url){
  //   let urlRegex = /^(?:(?:https?:\/\/)?(?:www\.)?(?:[\da-z.-]+)\.(?:[a-z]{2,})(?:\/[\w.-]*)*)$/;
  //   return url && urlRegex.test(url);
  // }

  startingSpaceValidation(value) {
    if (value !== "" && value.trim() === "") return true;
    return false;
  }

  validateArrayData(data, validateCallBack, oneValueRequired = true) {
    //* this is for checking for not data
    if (!Array.isArray(data) || data.length === 0) return !oneValueRequired;

    //* this is for validate all data
    return data.every(validateCallBack);
  }

  isBoolean(value, defaultValue = false) {
    return value === 'true' ? true : (value === 'false' ? false : defaultValue)
  }
}
export default CommonManager;

String.prototype.capitalizeWords = function () {
  let result = "";
  let capitalizeNext = true;

  for (let i = 0; i < this.length; i++) {
    const char = this[i];
    if (char === "_") {
      result += " ";
      capitalizeNext = true;
    } else if (capitalizeNext) {
      result += char.toUpperCase();
      capitalizeNext = false;
    } else {
      result += char;
    }
  }

  return result;
};

export const parseCheckLists = (json) => {
  const result = [];
  for (const key in json) {
    if (Object.hasOwn(json, key)) {
      const checkList = json[key];
      const topics = [];
      for (const topic in checkList) {
        if (Object.hasOwn(checkList, topic)) {
          topics.push({
            topic: topic.capitalizeWords(),
            checked: checkList[topic],
          });
        }
      }
      result.push({
        name: key.capitalizeWords(),
        topics,
      });
    }
  }
  return result;
}

// Private fields are not supported my webpack and current loader.
// export class URLRegexBuilder {
//   #protocol = false
//   #subdomain = false
//   #endpoints = false
//   #queryParams = false
//
//   constructor() {}
//
//   allowProtocol(assertion = true) {
//     this.#protocol = assertion;
//     return this;
//   }
//   allowSubdomain(assertion = true) {
//     this.#subdomain = assertion;
//     return this;
//   }
//   allowEndpoints(assertion = true) {
//     this.#endpoints = assertion;
//     return this;
//   }
//   allowQueryParams(assertion = true) {
//     this.#queryParams = assertion;
//     return this;
//   }
//
//   build() {
//     return new RegExp(`${this.#protocol ? "^(https?:\\/\\/)?" : ""}([\\w\\-]{1,}\\.)${this.#subdomain ? "+" : ""}\\w{2,12}${this.#endpoints ? "(\\/[\\w\\-]+)*" : ""}\\/?${this.#queryParams ? "(\\?(\\w+=\\w+&)*\\w+=\\w+)?" : ""}$`)
//   }
// }



// WEBPACK FOOTER //
// src/helpers/common.js